import { Injectable, NgZone } from '@angular/core';
import { LogService } from '@core/services/core/log.service';
import { MarketingCloudPluginService, MCNotification } from '@core/services/native-plugins/salesforce-marketing-cloud.service';
import { DeeplinkService } from '../deeplink.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationsReceiverService {

  constructor(
    private deeplink: DeeplinkService,
    private mcService: MarketingCloudPluginService,
    private log: LogService,
    private ngZone: NgZone
  ) { }

  registerSFMCNotificationListeners() {
    this.mcService.setOnNotificationOpenedListener(
      event => this.ngZone.run(() => this.onMCNotificationOpened(event)));
  }

  /****** NOTIFICATION LISTENERS ******/

  private onMCNotificationOpened(notification: MCNotification) {
    this.log.i(this, `SFMC notification opened`, notification);
    if (!notification?.values) { return; }
    this.log.i(this, `Handling notification action`, notification.values);
    this.onNotificationOpened(notification.values);
  }

  private onNotificationOpened(values: any) {
    this.deeplink.openNotificationDeeplink({ value: values.url });
  }
}
